<template>
  <div>
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :title="title"
      inline-message
      :width="isZh ? '1000px' : '1200px'"
    >
      <el-form
        ref="guaranteeForm"
        :model="guaranteeForm"
        :disabled="locked"
        :label-width="isZh ? '80px' : '100px'"
        label-position="left"
      >
        <el-row :gutter="10">
          <el-col :xs="12" :sm="12" :md="12">
            <el-form-item :label="$t('CargoMsg.Cargo_GuaranteeType')">
              <el-select
                v-model="guaranteeForm.guaranteeType"
                no="GuaranteeType"
                filterable
                :placeholder="$t('common.defaultPlaceholder')"
                @change="p=>{guaranteeForm.guaranteeType=p}"
              >
                <el-option
                  v-for="item in guaranteeTypeArrays"
                  :key="item.code"
                  :label="isZh ? item.chineseName :item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12">
            <el-form-item :label="$t('CargoMsg.Cargo_GuaranteeName')">
              <el-input
                v-model="guaranteeForm.guaranteeName"
                no="GuaranteeName"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="12" :sm="12" :md="12">
            <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')">
              <el-date-picker
                v-model="guaranteeForm.effectiveDate"
                no="EffectiveDate"
                type="date"
                style="width: 100%"
                :placeholder="$t('CargoMsg.Cargo_Select')+$t('CargoMsg.Cargo_EffectiveDate')"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12">
            <el-form-item :label="$t('CargoMsg.Cargo_InvalidDate')">
              <el-date-picker
                v-model="guaranteeForm.expiryDate"
                no="ExpiryDate"
                type="date"
                style="width: 100%"
                :placeholder="$t('CargoMsg.Cargo_Select')+$t('CargoMsg.Cargo_InvalidDate')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-tabs
          v-if="innerVisible"
          v-model="activeTabName"
          type="card"
          style="width:100%;"
        >
          <!--委托单位-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_AuthorizedClient')"
            name="customerGroup"
          >
            <group-tab ref="customer-group" :detail-value="customerDetailValue" :status="innerStatus" group-name="customer" :locked="locked" @func="getDataFormCustomer" />
          </el-tab-pane>
          <!--业务类型-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_BusinessType')"
            name="businessTypeGroup"
          >
            <group-tab ref="businessType-group" :detail-value="businessTypeDetailValue" :status="innerStatus" group-name="businessType" :locked="locked" @func="getDataFormBusinessTyp" />
          </el-tab-pane>
          <!--货物种类-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_TypeOfGoods')"
            name="cargoTypeGroup"
          >
            <group-tab ref="cargoType-group" :detail-value="cargoTypeDetailValue" :status="innerStatus" group-name="cargoType" :locked="locked" @func="getDataFormCargoType" />
          </el-tab-pane>
          <!--整拼类型-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_FLCLType')"
            name="containerType"
          >
            <group-tab ref="containerType-group" :detail-value="containerTypeDetailValue" :status="innerStatus" group-name="containerType" :locked="locked" @func="getDataFormContainerType" />
          </el-tab-pane>
          <!--起运港（海港）-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_PortOfLoadingSea')"
            name="seaPolGroup"
          >
            <group-tab ref="sea-pol-group" :detail-value="seaPolDetailValue" :status="innerStatus" group-name="seaPol" :locked="locked" @func="getDataFormSeaPolGroup" />
          </el-tab-pane>
          <!--目的港（海港）-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_DestinationPortSea')"
            name="seaPodGroup"
          >
            <group-tab ref="sea-pod-group" :detail-value="seaPodDetailValue" :status="innerStatus" group-name="seaPod" :locked="locked" @func="getDataFormSeaPodGroup" />
          </el-tab-pane>
          <!--发货人-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_Shipper')"
            name="shipperGroup"
          >
            <group-tab ref="shipper-group" :detail-value="shipperDetailValue" :status="innerStatus" group-name="shipper" :locked="locked" @func="getDataFormShipper" />
          </el-tab-pane>
          <!--收货人-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_Consignee')"
            name="consigneeGroup"
          >
            <group-tab ref="consignee-group" :detail-value="consigneeDetailValue" :status="innerStatus" group-name="consignee" :locked="locked" @func="getDataFormConsignee" />
          </el-tab-pane>
          <!--承运人-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_Carrier')"
            name="carrierGroup"
          >
            <group-tab ref="carrier-group" :detail-value="carrierDetailValue" :status="innerStatus" group-name="carrier" :locked="locked" @func="getDataFormCarrier" />
          </el-tab-pane>
          <!--订舱代理-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_BookingAgent')"
            name="bookingAgentGroup"
          >
            <group-tab ref="booking-agent-group" :detail-value="bookingAgentDetailValue" :status="innerStatus" group-name="bookingAgent" :locked="locked" @func="getDataFormBookingAgent" />
          </el-tab-pane>
          <!--航线/区域-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_ShippingRouteArea')"
            name="routeAreGroup"
          >
            <group-tab ref="route-are-group" :detail-value="routeAreaDetailValue" :status="innerStatus" group-name="routeArea" :locked="locked" @func="getDataFormRouteArea" />
          </el-tab-pane>
          <!--目的港代理-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_DestinationAgent')"
            name="destinationAgentGroup"
          >
            <group-tab ref="destination-agent-group" :detail-value="destinationAgentDetailValue" :status="innerStatus" group-name="destinationAgent" :locked="locked" @func="getDataFormDestinationAgent" />
          </el-tab-pane>
          <!--指定货代理	-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_NominatedAgent')"
            name="nominatedAgentGroup"
          >
            <group-tab ref="nominated-agent-group" :detail-value="nominatedAgentDetailValue" :status="innerStatus" group-name="nominatedAgent" :locked="locked" @func="getDataFormNominatedAgent" />
          </el-tab-pane>
          <!--可用分公司	-->
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_AvailableBranch')"
            name="availableBranchGroup"
          >
            <group-tab ref="available-branch-group" :detail-value="availableBranchDetailValue" :status="innerStatus" group-name="availableBranch" :locked="locked" @func="getDataFormAvialableBranch" />
          </el-tab-pane>
          <!--文件历史-->
          <el-tab-pane
            v-if="guaranteeForm.uuid || locked"
            :lazy="true"
            :label="$t('CargoMsg.Cargo_FileHistory')"
            name="fileHistoryGroup"
          >
            <guarantee-file-history-tab
              ref="file-history"
              :lazy="true"
              :context="this"
              :uuid="guaranteeForm.uuid"
            />
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer">
        <span style="padding-right: 5px;">
          <!--确定/取消-->
          <el-button no="confirm" :disabled="locked" type="primary" @click="submitForm">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import groupTab from '@/views/cargo/v0/Information/components/guarantee/groupTab'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { getGuaranteeDetail, addGuarantee, updateGuarantee } from '@/api/guarantee'
import { dateCompare } from '@/utils/commonUtil'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as GuaranteeType from '@/class/cargo/model/parameters/GuaranteeType'
import GuaranteeFileHistoryTab from '@/views/cargo/v0/Information/components/guarantee/guaranteeFileHistoryTab.vue'

export default {
  name: 'GuaranteeDialog',
  components: { GuaranteeFileHistoryTab, cargoAdvanceSelect, groupTab },
  props: {
    visible: { type: Boolean, required: true },
    context: { type: Object, required: true },
    status: { type: String, required: true },
    locked: { type: Boolean, required: true },
    guarantee: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      url: URL,
      guaranteeForm: {
        uuid: '',
        approvedState: 0,
        approvedBy: 0,
        createdBy: 0,
        dateApproved: '',
        guaranteeType: '',
        guaranteeName: '',
        effectiveDate: '',
        expiryDate: ''
      },
      allCompanyList: [],
      carrierCompanyList: [],
      guaranteeTypeArrays: [],
      activeTabName: 'customerGroup',
      // ====> 以下四个数组分别收集新增&维护保函弹窗页
      guaranteeCustomerList: [],
      guaranteeBusinessTypeList: [],
      guaranteeCargoTypeList: [],
      guaranteeContainerTypeList: [],
      guaranteeSeaPolList: [],
      guaranteeSeaPodList: [],
      guaranteeShipperList: [],
      guaranteeConsigneeList: [],
      guaranteeCarrierList: [],
      guaranteeBookingAgentList: [],
      guaranteeRouteAreaList: [],
      guaranteeDestinationAgentList: [],
      guaranteeNominatedAgentList: [],
      guaranteeAvailableBranchList: [],
      guaranteeFileHistoryList: [],
      // <====
      customerDetailValue: [],
      businessTypeDetailValue: [],
      cargoTypeDetailValue: [],
      containerTypeDetailValue: [],
      seaPolDetailValue: [],
      seaPodDetailValue: [],
      shipperDetailValue: [],
      consigneeDetailValue: [],
      carrierDetailValue: [],
      bookingAgentDetailValue: [],
      routeAreaDetailValue: [],
      destinationAgentDetailValue: [],
      nominatedAgentDetailValue: [],
      availableBranchDetailValue: [],
      fileHistoryDetailValue: [],
      innerStatus: 'add'
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    title() {
      const op = this.innerStatus === 'edit' ? this.$t('CargoMsg.Cargo_Edit') : this.$t('CargoMsg.Cargo_New')
      return op + ' ' + this.$t('CargoMsg.Cargo_Guarantee')
    },
    carrierMethodParams() {
      return { seaCmp: true, airCmp: false }
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        this.innerStatus = this.status
        await this.initBasicData()
        // 必须在innerVisible赋值前执行，否则费用明细列表显示空白
        await this.onshow()
      }
      this.innerVisible = val
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.resetDialog()
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    this.guaranteeTypeArrays = [...SystemConstants.GUARANTEE_TYPES]
    await this.initBasicData()
  },
  methods: {
    async onshow() {
      if (!['add', 'edit'].includes(this.innerStatus)) {
        this.innerVisible = false
        return
      }
      if (this.innerStatus === 'edit') {
        await this.editHandle()
      }
    },
    async editHandle() {
      const self = this
      self.loading = getLoading()
      await getGuaranteeDetail({ uuid: this.guarantee.uuid }).then(res => {
        this.detailPostHandle(self, res)
      }).finally(
        self.loading.close()
      )
    },
    detailPostHandle(self, res) {
      Object.assign(self.guaranteeForm, this.guarantee)
      self.activeTabName = 'customerGroup'
      // 解析条件
      const guaranteeCriteria = res.data['guaranteeCriteriaList'] || []
      // 委托单位
      const customerDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.CUSTOMER.type)
      // 业务类型
      const businessTypeDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.BUSINESS_TYPE.type)
      // 整拼类型
      const containerTypeDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.CONTAINER_TYPE.type)
      // 货物种类
      const cargoTypeDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.CARGO_TYPE.type)
      // 起运港（海港）
      const seaPolDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.SEA_POL.type)
      // 目的港（海港）
      const seaPodDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.SEA_POD.type)
      // 发货人
      const shipperDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.SHIPPER.type)
      // 收货人
      const consigneeDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.CONSIGNEE.type)
      // 承运人
      const carrierDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.CARRIER.type)
      // 订舱代理
      const bookingAgentDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.BOOKING_AGENT.type)
      // 航线/区域
      const routeAreaDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.ROUTE_AREA.type)
      // 目的港代理
      const destinationAgentDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.DESTINATION_AGENT.type)
      // 指定货代理
      const nominatedAgentDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.NOMINATED_AGENT.type)
      // 可用分公司
      const availableBranchDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.AVAILABLE_BRANCH.type)
      // 文件历史
      const fileHistoryDetail = guaranteeCriteria.filter(item => item['criteriaType'] === GuaranteeType.FILE_HISTORY.type)

      // 1. 分别为负责传值给子组件的xxxValue变量赋值 2. 分别为存储最终结果的各项xxxList变量赋值
      self.customerDetailValue = [...customerDetail]
      self.businessTypeDetailValue = [...businessTypeDetail]
      self.cargoTypeDetailValue = [...cargoTypeDetail]
      self.containerTypeDetailValue = [...containerTypeDetail]
      self.seaPolDetailValue = [...seaPolDetail]
      self.seaPodDetailValue = [...seaPodDetail]
      self.shipperDetailValue = [...shipperDetail]
      self.consigneeDetailValue = [...consigneeDetail]
      self.carrierDetailValue = [...carrierDetail]
      self.bookingAgentDetailValue = [...bookingAgentDetail]
      self.routeAreaDetailValue = [...routeAreaDetail]
      self.destinationAgentDetailValue = [...destinationAgentDetail]
      self.nominatedAgentDetailValue = [...nominatedAgentDetail]
      self.availableBranchDetailValue = [...availableBranchDetail]
      self.fileHistoryDetailValue = [...fileHistoryDetail]

      self.guaranteeCustomerList = [...customerDetail]
      self.guaranteeBusinessTypeList = [...businessTypeDetail]
      self.guaranteeCargoTypeList = [...cargoTypeDetail]
      self.guaranteeContainerTypeList = [...containerTypeDetail]
      self.guaranteeSeaPolList = [...seaPolDetail]
      self.guaranteeSeaPodList = [...seaPodDetail]
      self.guaranteeShipperList = [...shipperDetail]
      self.guaranteeConsigneeList = [...consigneeDetail]
      self.guaranteeCarrierList = [...carrierDetail]
      self.guaranteeBookingAgentList = [...bookingAgentDetail]
      self.guaranteeRouteAreaList = [...routeAreaDetail]
      self.guaranteeDestinationAgentList = [...destinationAgentDetail]
      self.guaranteeNominatedAgentList = [...nominatedAgentDetail]
      self.guaranteeAvailableBranchList = [...availableBranchDetail]
      self.guaranteeFileHistoryList = [...fileHistoryDetail]
    },
    getDataFormCustomer(data) {
      this.guaranteeCustomerList = [...data]
    },
    getDataFormBusinessTyp(data) {
      this.guaranteeBusinessTypeList = [...data]
    },
    getDataFormCargoType(data) {
      this.guaranteeCargoTypeList = [...data]
    },
    getDataFormContainerType(data) {
      this.guaranteeContainerTypeList = [...data]
    },
    getDataFormSeaPolGroup(data) {
      this.guaranteeSeaPolList = [...data]
    },
    getDataFormSeaPodGroup(data) {
      this.guaranteeSeaPodList = [...data]
    },
    getDataFormShipper(data) {
      this.guaranteeShipperList = [...data]
    },
    getDataFormConsignee(data) {
      this.guaranteeConsigneeList = [...data]
    },
    getDataFormCarrier(data) {
      this.guaranteeCarrierList = [...data]
    },
    getDataFormBookingAgent(data) {
      this.guaranteeBookingAgentList = [...data]
    },
    getDataFormRouteArea(data) {
      this.guaranteeRouteAreaList = [...data]
    },
    getDataFormDestinationAgent(data) {
      this.guaranteeDestinationAgentList = [...data]
    },
    getDataFormNominatedAgent(data) {
      this.guaranteeNominatedAgentList = [...data]
    },
    getDataFormAvialableBranch(data) {
      this.guaranteeAvailableBranchList = [...data]
    },
    // 条件数据组合
    guaranteeCriteriaList() {
      return [
        ...this.guaranteeCustomerList,
        ...this.guaranteeBusinessTypeList,
        ...this.guaranteeCargoTypeList,
        ...this.guaranteeContainerTypeList,
        ...this.guaranteeSeaPolList,
        ...this.guaranteeSeaPodList,
        ...this.guaranteeShipperList,
        ...this.guaranteeConsigneeList,
        ...this.guaranteeCarrierList,
        ...this.guaranteeBookingAgentList,
        ...this.guaranteeRouteAreaList,
        ...this.guaranteeDestinationAgentList,
        ...this.guaranteeNominatedAgentList,
        ...this.guaranteeAvailableBranchList,
        ...this.guaranteeFileHistoryList
      ]
    },
    // 提交
    async submitForm() {
      // 校验表单
      if (!this.toCheckCostPlanForm(this.guaranteeForm)) {
        return
      }
      const guaranteeCriteriaList = this.guaranteeCriteriaList()
      // 组建请求数据
      const data = {
        ...this.guaranteeForm,
        guaranteeCriteriaList: guaranteeCriteriaList
      }
      data.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      if (this.innerStatus === 'edit') {
        await updateGuarantee(data).then(res => {
          this.invokeSuccessPostHandle()
        }).finally(() => loading.close())
      } else {
        await addGuarantee(data).then(res => {
          this.invokeSuccessPostHandle()
        }).finally(() => loading.close())
      }
    },
    invokeSuccessPostHandle() {
      this.innerVisible = false
      this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      this.context.fetchGuaranteeList()
    },
    // 检查表单
    toCheckCostPlanForm(opt) { // opt=> add,edit
      const { guaranteeType, guaranteeName } = opt
      let errorMsg = ''
      errorMsg += !guaranteeType ? this.$t('CargoMsg.Cargo_PleaseSelectGuaranteeType') + ',' : ''
      errorMsg += !guaranteeName ? this.$t('CargoMsg.Cargo_PleaseEnterGuarantrrName') + ',' : ''
      if (this.guaranteeForm.effectiveDate && this.guaranteeForm.expiryDate) {
        errorMsg += dateCompare(this.guaranteeForm.effectiveDate, this.guaranteeForm.expiryDate) >= 0 ? this.$t('CargoMsg.Cargo_EffectiveDateMustBeLessThanTheExpirationDate') + ',' : ''
      }
      if (!errorMsg) {
        return true
      }
      this.$message.error(errorMsg)
      return false
    },
    resetDialog() {
      // 该数组维护新增&维护方案弹窗页费用明细项
      this.dgSchemeDetail = []
      // ====> 以下四个数组分别收集新增&维护方案弹窗页除费用明细外四个tab下的表格值维护对应费用条件
      this.guaranteeCustomerList = []
      this.guaranteeBusinessTypeList = []
      this.guaranteeCargoTypeList = []
      this.guaranteeContainerTypeList = []
      this.guaranteeSeaPolList = []
      this.guaranteeSeaPodList = []
      this.guaranteeShipperList = []
      this.guaranteeConsigneeList = []
      this.guaranteeCarrierList = []
      this.guaranteeBookingAgentList = []
      this.guaranteeRouteAreaList = []
      this.guaranteeDestinationAgentList = []
      this.guaranteeNominatedAgentList = []
      this.guaranteeAvailableBranchList = []
      this.guaranteeFileHistoryList = []
      // <====
      this.customerDetailValue = []
      this.businessTypeDetailValue = []
      this.cargoTypeDetailValue = []
      this.containerTypeDetailValue = []
      this.seaPolDetailValue = []
      this.seaPodDetailValue = []
      this.shipperDetailValue = []
      this.consigneeDetailValue = []
      this.carrierDetailValue = []
      this.bookingAgentDetailValue = []
      this.routeAreaDetailValue = []
      this.destinationAgentDetailValue = []
      this.nominatedAgentDetailValue = []
      this.availableBranchDetailValue = []
      this.fileHistoryDetailValue = []
      this.resetForm()
      this.innerStatus = 'add'
    },
    resetForm() {
      this.guaranteeForm = {
        uuid: '',
        version: '',
        approvedState: 0,
        approvedBy: 0,
        createdBy: 0,
        dateApproved: '',
        guaranteeType: '',
        guaranteeName: '',
        effectiveDate: '',
        expiryDate: ''
      }
    },
    // 更新承运人数据源列表
    refreshCarrierCompanyList() {
      this.carrierCompanyList = this.allCompanyList.filter(company => {
        let result = true
        for (const key in this.carrierMethodParams) {
          result = result && company[key] === this.carrierMethodParams[key]
        }
        return result
      })
    },
    async initBasicData() {
      const companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
      if (companyList && companyList.length > 0) {
        if (this.$store.getters.currentOfficeId === 1) {
          this.allCompanyList = companyList.filter(p => p.branchId === 1) || []
        } else {
          this.allCompanyList = companyList.filter(p => p.branchId === 1 || p.branchId === this.$store.getters.currentOfficeId) || []
        }
      } else {
        this.allCompanyList = []
      }
      this.refreshCarrierCompanyList()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select{
  /deep/ .el-select__tags{
    & > span{
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      display: flex;
      span{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
